import { OrderSort } from 'common/@types';
import { Brand, Category, ChildrenProduct, ExtraProduct, KitchenCenter } from 'common/models';

export function descendingComparator<T>(a: T, b: T, orderBy: keyof T) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

export function getComparator<Key extends keyof any>(
  order: OrderSort,
  orderBy: Key
): (
  a: {
    [key in Key]: Date | string | number | Brand | KitchenCenter | Category | ChildrenProduct | ExtraProduct | null;
  },
  b: { [key in Key]: Date | string | number | Brand | KitchenCenter | Category | ChildrenProduct | ExtraProduct | null }
) => number {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

export function stableSort<T>(array: readonly T[], comparator: (a: T, b: T) => number) {
  const stabilizedThis = array.map((el, index) => [el, index] as [T, number]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) {
      return order;
    }
    return a[1] - b[1];
  });

  return stabilizedThis.map((el) => el[0]);
}
